import { render, staticRenderFns } from "./AddEmailWorkspace.vue?vue&type=template&id=72bef268"
import script from "./AddEmailWorkspace.vue?vue&type=script&lang=js"
export * from "./AddEmailWorkspace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports